import { takeEvery, call, put } from 'redux-saga/effects';
import {
    FETCH_TRAINING_READINESS,
    FETCH_TRAINING_READINESS_START,
    FETCH_TRAINING_READINESS_SUCCESS,
    FETCH_TRAINING_READINESS_FAIL
} from '../actions/ActionTypes';
import { gcApi } from '../config/axios';

export function* fetchTrainingReadinessData(action) {
    const { calendarDate, key } = action.payload;

    try {
        yield put({
            type: FETCH_TRAINING_READINESS_START
        });

        const response = yield call(gcApi.get, `/metrics-service/metrics/trainingreadiness/${calendarDate}`);

        yield put({
            type: FETCH_TRAINING_READINESS_SUCCESS,
            data: response.data,
            date: calendarDate,
            key: key
        });
    } catch (e) {
        yield put({
            type: FETCH_TRAINING_READINESS_FAIL,
            data: { errorMessage: e },
            date: calendarDate,
            key: key
        });
    }
}

export const trainingReadinessSagas = [takeEvery(FETCH_TRAINING_READINESS, fetchTrainingReadinessData)];
